import {
  convertPhysicalAlignmentToLogical,
  type Direction,
  type WithInherit,
  type LogicalAlignment,
} from '@wix/editor-elements-common-utils';
import type { ExpandableMenuProperties } from '../../ExpandableMenu.types';

export const getDirectionFallbackValue = (
  legacyArrowPosition: ExpandableMenuProperties['menuArrowDirection'],
): WithInherit<Direction> =>
  legacyArrowPosition === 'right' ? 'inherit' : 'rtl';

export const getAlignFallbackValue = (
  itemsAlignment: ExpandableMenuProperties['itemsAlignment'],
  legacyArrowPosition: ExpandableMenuProperties['menuArrowDirection'],
): LogicalAlignment => {
  const legacyDirection = legacyArrowPosition === 'right' ? 'ltr' : 'rtl';

  return convertPhysicalAlignmentToLogical(itemsAlignment, legacyDirection);
};
